/**
 * ClientPortalContext — lets ClientPortalLayout hand its single GET /portal/{token}
 * result (and a quiet refresh) to the UnifiedClientPortal rendered inside it, so the
 * /client routes make one request instead of two and show one header.
 */
import { createContext, useContext } from 'react';

export interface ClientPortalContextValue {
  data: any | null;
  refresh: () => Promise<void>;
  token?: string;
  source?: 'link' | 'session';
  clarificationToken?: string;
}

export const ClientPortalContext = createContext<ClientPortalContextValue | null>(null);

export const useClientPortalContext = () => useContext(ClientPortalContext);

const PLACEHOLDER_NAMES = new Set(['valued client', 'client']);

/** The client's real name, or null when the backend only has its placeholder. */
export function portalDisplayName(data?: { client_name?: string | null; claimant_name?: string | null } | null): string | null {
  const name = (data?.client_name || data?.claimant_name || '').trim();
  if (!name || PLACEHOLDER_NAMES.has(name.toLowerCase())) return null;
  return name;
}
